(function () {
  'use strict';
  var path = window.location.pathname.replace(/\/$/, '');
  var match = path.match(/\/collections\/([^/?#]+)$/);
  if (!match) return;
  var handle = decodeURIComponent(match[1]);

  var TITLES = {
    'e-scooters': 'Electric Scooters',
    'e-bikes': 'Electric Bikes',
    'electric-dirt-bikes': 'Electric Dirt Bikes',
    'apollo': 'Apollo Electric Scooters',
    'heybike': 'Heybike Electric Bikes',
    'iscooter': 'iScooter Electric Scooters',
    'teverun': 'Teverun Electric Scooters',
    'dualtron': 'Dualtron Electric Scooters'
  };

  function cleanTitle(raw) {
    var title = (raw || '').replace(/\s+/g, ' ').trim();
    title = title
      .replace(/\s+(for\s+sale\s+in\s+vancouver|in\s+vancouver)(\s*,?\s*bc)?/ig, '')
      .replace(/\s+vancouver\s+canada/ig, '')
      .replace(/\s+vancouver\s*,?\s*bc/ig, '')
      .replace(/\s+vancouver/ig, '')
      .replace(/\s+canada/ig, '')
      .replace(/\s+/g, ' ')
      .trim();
    return TITLES[handle] || title || handle.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>\"]/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;'})[c]; });
  }

  function hideCanadaEditorial() {
    var roots = document.querySelectorAll('.pmb-collection-hero, .collection-hero__description, [id*="__pmb_guide"], [id*="__pmb_support"], [id*="__pmb_areas_strip"], [id*="__multicolumn_"], [id*="__rich_text_"], [id*="__collapsible_content_"]');
    roots.forEach(function (root) {
      if (root.closest && root.closest('#ProductGridContainer')) return;
      if (!root.matches('.pmb-collection-hero')) {
        var rootText = (root.textContent || '').toLowerCase();
        if (/vancouver|metro vancouver|burnaby|richmond|coquitlam|surrey|north vancouver|new westminster|british columbia|\bbc\b|canada|grant st|local pickup|repair|workshop|battery refurbishment/.test(rootText)) root.style.display = 'none';
        return;
      }
      root.querySelectorAll('p, a, span, small, .rte, .pmb-collection-hero__meta').forEach(function (el) {
        var t = (el.textContent || '').toLowerCase();
        if (/vancouver|metro vancouver|burnaby|richmond|coquitlam|surrey|north vancouver|new westminster|british columbia|\bbc\b|canada|grant st|local pickup|repair|workshop|battery refurbishment|assembled\s*&\s*tuned|road-tested/.test(t)) {
          el.style.display = 'none';
        }
      });
    });
  }

  function hasActiveFilters() {
    var params = new URLSearchParams(window.location.search);
    var active = false;
    params.forEach(function (_, key) { if (key.indexOf('filter.') === 0) active = true; });
    return active;
  }

  function collectionIsEmpty() {
    var grid = document.getElementById('product-grid');
    if (!grid) return false;
    if (grid.classList.contains('collection--empty')) return !hasActiveFilters();
    return grid.querySelectorAll('.grid__item').length === 0 && !hasActiveFilters();
  }

  function addIntro(title) {
    if (document.querySelector('.pmb-us-collection-intro')) return;
    var grid = document.querySelector('.pmb-collection-grid, #ProductGridContainer');
    if (!grid || !grid.parentNode) return;
    var wrap = document.createElement('div');
    wrap.className = 'pmb-us-collection-intro';
    wrap.innerHTML = '<div class="pmb-us-collection-intro__box"><span class="pmb-us-collection-intro__tag">United States Catalog</span><h2>' + escapeHtml(title) + '</h2><p>Shop the current ProMechBC U.S. selection for this collection. Prices are shown in USD, with shipping available within the contiguous United States. Alaska and Hawaii are not currently served.</p></div>';
    grid.parentNode.insertBefore(wrap, grid);
  }

  function showEmptyState(title) {
    var existing = document.querySelector('.pmb-us-collection-empty');
    if (existing) return;
    var gridContainer = document.getElementById('ProductGridContainer');
    var filters = document.getElementById('main-collection-filters');
    var intro = document.querySelector('.pmb-us-collection-intro');
    if (intro) intro.remove();
    if (filters) filters.style.display = 'none';
    if (gridContainer) gridContainer.style.display = 'none';
    var anchor = document.querySelector('.pmb-collection-grid') || gridContainer;
    if (!anchor || !anchor.parentNode) return;
    var state = document.createElement('section');
    state.className = 'pmb-us-collection-empty';
    state.innerHTML = '<span class="pmb-us-collection-empty__tag">United States Catalog</span><h2>Not currently available in the U.S.</h2><p>' + escapeHtml(title) + ' does not currently contain products approved for the ProMechBC U.S. storefront.</p><div class="pmb-us-collection-empty__actions"><a href="/en-us/collections/e-scooters">Shop electric scooters</a><a href="/en-us/collections/e-bikes">Shop electric bikes</a></div>';
    anchor.parentNode.insertBefore(state, anchor);
  }

  function apply() {
    var h1 = document.querySelector('.collection-hero__title, .pmb-collection-hero h1, h1');
    var current = h1 ? h1.textContent : document.title.split('|')[0];
    var title = cleanTitle(current);
    if (h1) h1.textContent = title;
    hideCanadaEditorial();

    document.title = title + ' | ProMechBC';
    var meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Shop ' + title + ' in the ProMechBC United States catalog. View current U.S. availability and USD pricing. Shipping is available within the contiguous United States.');

    if (collectionIsEmpty()) showEmptyState(title);
    else addIntro(title);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
